import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getHttpInstance } from '../../../../services/defaultHttpService';
import { replaceTokensInString } from '../../../../utils';
import endpoints from '../../../../constants/endpoints';
import { enrichLayoutData, getEspotNames, getPageId } from '../utils';
import { setError } from '../../../../store/exception/actions';
import { ERROR_DOMAIN, ERROR_PATH } from '../../../../constants/errorConstants';
import { normalizeError } from '../../../../store/exception/utils';

export default () => {
  const [layoutData, setLayoutData] = useState({});
  const [espotNames, setEspotNames] = useState([]);
  const [isLayoutLoading, setIsLayoutLoading] = useState(true);
  const { storeId } = useSelector(state => state.common);
  const dispatch = useDispatch();

  useEffect(() => {
    const pageId = getPageId();
    const url = replaceTokensInString(
      endpoints.CMC_MARKETING_LAYOUT_DATA_URL,
      storeId,
      pageId
    );
    const http = getHttpInstance();
    http
      .get(url)
      .then(({ data }) => {
        const serverLayoutData = data.resultList[0].widget;
        const enrichedLayout = enrichLayoutData(serverLayoutData);
        setEspotNames(getEspotNames(enrichedLayout));
        setLayoutData(enrichedLayout);
      })
      .catch(err =>
        dispatch(
          setError(
            ERROR_DOMAIN.MARKETING,
            ERROR_PATH.PAGE_LAYOUT,
            normalizeError(err)
          )
        )
      )
      .finally(() => setIsLayoutLoading(false));
  }, [dispatch, storeId]);

  return { layoutData, espotNames, isLayoutLoading };
};
